import { Chip } from "@mui/material";

export const ArrayNumberColorChip = ({ list }) => {
  return list.map(({ value, color }, index) => {
    return (
      <Chip
        key={index}
        label={
          <span style={{ fontSize: "0.75rem" }}>
            <strong>{value}</strong>
          </span>
        }
        size="small"
        sx={{
          mr: 0.8,
          mb: 0.5,
          fontWeight: 500,
          boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
          backgroundColor: { color },
        }}
        variant="filled"
      />
    );
  });
};
